import script from "./KanbanView.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanView.vue?vue&type=script&setup=true&lang=js"

import "./KanbanView.vue?vue&type=style&index=0&id=d9360bd4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9360bd4"]])

export default __exports__